import store from './store/index';
import i18n from './i18n/i18n';
import config from './config/config';
import api from './api/api';

export default function beforeRun() {
    const userLogged = getLocalStorage(config.sessionLSKey);

    const selectedLang = window.localStorage.getItem('FV_LANG');
    // console.log("navigator -> " + navigator.language.toLocaleLowerCase());
    // console.log("selectedLangTmp -> " + selectedLang);

    if (navigator.language.toLocaleLowerCase() != "es-es" && navigator.language.toLocaleLowerCase() != "es") {
        i18n.locale = "en";
    } else {
        i18n.locale = selectedLang;
    }

    if (selectedLang != null) {
        i18n.locale = selectedLang;
    }

    if (!userLogged) {
        return store.dispatch('DO_ANONYMOUS_LOGIN').catch((err) => console.log(err));
    }

    if (userLogged) {
        const isAnonymus = userLogged.usr === config.anonymousUser;
        return setSessionDataToStore(userLogged, isAnonymus);
    }
}

const getLocalStorage = (key) => JSON.parse(window.localStorage.getItem(key));
const setSessionDataToStore = (sessionData, isAnonymus) => {
    const selectedRol = window.localStorage.getItem(config.workinRoleLSKey);
    const selectedLang = window.localStorage.getItem('FV_LANG');

    return api.externalSale
        .checktoken(sessionData.jwt)
        .then(() =>
            Promise.all([
                store.commit('LOGIN_SUCCESSFULL', sessionData),
                store.commit('SET_IS_ANONYMUS', isAnonymus),
                store.commit('SET_LANG', selectedLang),
                store.commit('SET_SELECTED_ROL', selectedRol)
            ])
        )
        .catch(() => store.dispatch('DO_ANONYMOUS_LOGIN'))
        .catch((err) => console.log(err));
};
